import {AnyAction} from 'redux';
import Types from '../../../actions/Types';

import Announcement from '../../../../domain/entities/writer/Announcement';

export default function reducer(
  state: {[key: number]: Announcement} = {},
  action: AnyAction,
): {[key: number]: Announcement} {
  switch (action.type) {
    case Types.IndexWriterAnnouncementsSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: Announcement}, record: Announcement) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowWriterAnnouncementSuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
